<template>
  <!-- <VideoPlayer/> -->
  <router-view :key="routerKey"></router-view>
</template>

<script setup>
// import VideoPlayer from './components/VideoPlayer.vue'
import {computed} from 'vue'
import { useRoute } from 'vue-router'
 
const route = useRoute()
 
const routerKey = computed(() => {
  return route.path + Math.random()
})
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
